<template>
  <div>
    <editor
      :init="init"
      :value="value"
      :disabled="readonly === true ? true : false"
      @input="$emit('onChange', $event)"
    />
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import { apiDomain, apiDomainFile } from "@/store/constants";
import axios from "axios";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    readonly: {
      default: false,
    },
  },
  components: {
    editor: Editor,
  },
  created() {
    this.init.width = this.width;
    this.init.height = this.height;
  },
  data() {
    return {
      init: {
        height: 350,
        width: "100%",
        branding: false,
        elementpath: false,
        plugins: [
          "advlist autolink link image lists charmap print preview hr anchor pagebreak",
          "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
          "table emoticons template paste help",
        ],
        toolbar:
          "undo redo | styleselect | fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | " +
          "bullist numlist outdent indent | link image | print preview media fullscreen | " +
          "forecolor backcolor emoticons",
        menubar: false, //"favs file edit view insert format tools table help",
        images_upload_handler: function (blobInfo, success, failure) {
          var formData;
          var file = blobInfo.blob();
          formData = new FormData();
          formData.append("file", file, file.name);
          formData.append("folder", "/uploads/form-b/images-text-editor/");
          axios
            .post(apiDomain + "api/upload-image", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log(res);
              success(apiDomainFile + res?.data?.attachments?.full_path);
            })
            .catch((err) => {
              failure("HTTP Error: " + err.message);
            });
        },
      },
    };
  },
};
</script>

<style></style>
